export const QUERY_KEYS = {
  header: ['header'],

  home: ['home'],
  mt: ['mt'],
  account: ['account'],
  about: ['about'],
  partners: ['partners'],
  contact: ['contact'],

  marketsList: () => ['markets', 'list'],
  marketsPage: slug => ['markets', slug],

  tutorial: ['tutorial'],
  tutorialList: params => ['tutorial', 'list', params],
  tutorialItem: slug => ['tutorial', 'item', slug],

  news: ['news'],
  newsList: params => ['news', 'list', params],
  newsItem: slug => ['news', 'item', slug],

  glossary: ['glossary'],
  glossaryList: params => ['glossary', 'list', params],

  faq: ['faq'],
  faqCategories: () => ['faq', 'categories'],
  faqList: () => ['faq', 'list'],
  faqByCategory: slug => ['faq', 'category', slug],

  legalPack: ['legal-pack'],
  legalPackPage: slug => ['legal-pack', slug],

  subscribeBlock: ['subscribe'],

  footer: ['footer'],
};
